'use strict';

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

ngModule.directive("obsDepartementPanel", function (applicationSettings, $translate, $http, obsPanelService, obsUtils) {
    return {
        restrict: "E",
        replace: true,
        template: require("./obsDepartementPanel.html"),
        link: function ($scope, $el, $attrs) {

            $scope.optionsCollapsed = false;
            $scope.filtresCollapsed = true;

            $scope.datatypes = [
                {name: $translate('observatoire.datatype.Dette'), value: 'ENCOURS_DETTE'},
                {name: $translate('observatoire.datatype.Annuite'), value: 'ANNUITE_DETTE'},
                {name: $translate('observatoire.datatype.Amortissement'), value: 'AMORTISSEMENT_DETTE'},
                {name: $translate('observatoire.datatype.Interet'), value: 'INTERET_DETTE'},
                {name: $translate('observatoire.datatype.Dotations'), value: 'DOTATION_GLOBALE_FONCTIONNEMENT'},
                {name: $translate('observatoire.datatype.RecetteDeFonctionnement'), value: 'RECETTES_FONCTIONNEMENT'},
                {name: $translate('observatoire.datatype.DetteSurRecetteDeFonctionnement'), value: 'DETTE_SUR_RECETTES_FONCTIONNEMENT'},
                {name: $translate('observatoire.datatype.PopulationDGFIP'), value: 'POPULATION_DGFIP'},
                {name: $translate('observatoire.datatype.POPULATION_DGCL_DGF'), value: 'POPULATION_DGCL_DGF'},
              //  {name: $translate('observatoire.datatype.POPULATION_INSEE'), value: 'POPULATION_INSEE'}

            ];

            $scope.isParHab = (datatype) => {
                return !(
                    datatype === 'POPULATION_DGCL_DGF' ||
                    datatype === 'POPULATION_INSEE' ||
                    datatype === 'POPULATION_DGFIP' ||
                    datatype === 'DETTE_SUR_POTENTIEL_FINANCIER' ||
                    datatype === 'DETTE_SUR_RECETTES_FONCTIONNEMENT');
            };

            $scope.sourcesPopulation = [
                {name: 'DGFiP', value: 'DGFIP'},
                {name: 'DGF', value: 'DGCL_DGF'},
               // {name: 'INSEE', value: 'INSEE'},

            ];


            $scope.zonages = [
                {name: $translate('observatoire.zonage.France'), value: 'FRANCE'},
            ];

            if (!$scope.observatoryConfig.publicObs) {
                $scope.zonages.push({name: $translate('observatoire.zonage.Panel'), value: 'PANEL'});


                obsPanelService.getPanels().then((panels) => {
                    $scope.panels = panels;
                    if ($scope.panels.length>0) {
                        $scope.communeParams.panelId = $scope.panels[0].id;
                    }
                });
            }

            $scope.representations = [
                {name: $translate('observatoire.representation.Absolu'), value: 'ABSOLU'},
                {name: $translate('observatoire.representation.RelatifCommune'), value: 'RELATIF'}
            ];

            $scope.unites = [
                {name: $translate('observatoire.unite.EnValeur'), value: 'VALEUR'},
                {name: $translate('observatoire.unite.EnPourcentage'), value: 'POURCENTAGE'}
            ];

            $scope.temporalites = [
                {name: $translate('observatoire.temporalite.Instantané'), value: 'INSTANTANE'},
                {name: $translate('observatoire.temporalite.Evolution'), value: 'EVOLUTION'}
            ];

            $scope.anneesDefaut = obsUtils.getAnneesDispo('departement');

            $scope.annees = $scope.anneesDefaut;

            $scope.$watch('communeParams', function () {

                $scope.annees = $scope.anneesDefaut;
                if (!$scope.communeParams.anneeInstantane) {
                    $scope.communeParams.anneeInstantane = obsUtils.getDerniereAnneeDispo();
                }
                if (!$scope.communeParams.anneeDebut) {
                    $scope.communeParams.anneeDebut = obsUtils.getDerniereAnneeDispo() - 1;
                }
                if (!$scope.communeParams.anneeFin) {
                    $scope.communeParams.anneeFin = obsUtils.getDerniereAnneeDispo();
                }

            }, true);
        }
    };
});


// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/maps/departement/obsDepartementPanel.js